export default __webpack_public_path__ + "static/media/Residential-.23e35d72.jpg";